import { LitElement, html, svg } from 'lit';

export class IconUsers32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>To personer</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM1 27a9 9 0 0 1 18-.074M23.636 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM21.084 20.09A7.367 7.367 0 0 1 31 26.974"></path></svg>`; }
}
if (!customElements.get('f-icon-users32', IconUsers32)) {
  customElements.define('f-icon-users32', IconUsers32);
}